import { IServerOrder } from '@rbi-ctg/menu';
import { DONATIONS } from 'hooks/use-donations/constants';

export const getRoundUpDonations = (serverOrder: IServerOrder | null) =>
  serverOrder?.cart?.donations?.find(({ name }) => name === DONATIONS.ROUND_UP);
